import { z } from '@hono/zod-openapi'
import { idZ as planMasterIdZ } from './plan_master_type'

// id
export const idZ = z
  .number()
  .openapi({ description: 'プランID（プラン契約の識別子）', example: 1 })
export type id = z.infer<typeof idZ>

// planMasterId
export { planMasterIdZ }
export type planMasterId = z.infer<typeof planMasterIdZ>

// roomId (nullable: 居室単位の契約時のみ紐づく)
export const roomIdZ = z.number().nullable().openapi({
  description: '契約対象の部屋ID。居室単位の契約時のみ値が入る',
  example: 201,
})
export type roomId = z.infer<typeof roomIdZ>

// tenantId
export const tenantIdZ = z
  .number()
  .nullable()
  .openapi({ description: '契約時点の賃借人ID', example: 301 })
export type tenantId = z.infer<typeof tenantIdZ>

// monthlyPrice
export const monthlyPriceZ = z
  .number()
  .openapi({ description: '契約時点の月額料金（円・税抜）', example: 300.0 })
export type monthlyPrice = z.infer<typeof monthlyPriceZ>

// startDate
export const startDateZ = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .openapi({
    description: 'プラン契約の開始日（YYYY-MM-DD）',
    example: '2024-01-01',
  })
export type startDate = z.infer<typeof startDateZ>

// endDate
export const endDateZ = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .nullable()
  .openapi({
    description: 'プラン契約の終了日（YYYY-MM-DD）。null は継続中',
    example: null,
  })
export type endDate = z.infer<typeof endDateZ>

// endReason
export const PLAN_END_REASON_TENANT_MOVE_OUT = 'tenant_move_out'
export const PLAN_END_REASON_OWNER_CHANGE = 'owner_change'
export const PLAN_END_REASON_VALUES = [
  PLAN_END_REASON_TENANT_MOVE_OUT,
  PLAN_END_REASON_OWNER_CHANGE,
] as const
export const PLAN_END_REASONS = [
  { key: PLAN_END_REASON_TENANT_MOVE_OUT, value: '退去（入居者都合）' },
  { key: PLAN_END_REASON_OWNER_CHANGE, value: '所有者変更' },
] as const

export const endReasonZ = z.enum(PLAN_END_REASON_VALUES).nullable().openapi({
  description:
    '契約終了理由（tenant_move_out:退去(入居者都合) / owner_change:所有者変更）',
  example: PLAN_END_REASON_TENANT_MOVE_OUT,
})
export type endReason = z.infer<typeof endReasonZ>

// createdAt
export const createdAtStringZ = z.string().openapi({
  description: '作成日時（ISO8601）',
  example: '2024-01-01T00:00:00.000Z',
})
export type createdAtString = z.infer<typeof createdAtStringZ>

export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>

// updatedAt
export const updatedAtStringZ = z.string().openapi({
  description: '更新日時（ISO8601）',
  example: '2024-01-01T00:00:00.000Z',
})
export type updatedAtString = z.infer<typeof updatedAtStringZ>

export const updatedAtDateZ = z
  .date()
  .openapi({ example: '2024-01-01T00:00:00.000Z' })
export type updatedAtDate = z.infer<typeof updatedAtDateZ>
